import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import { AppBar, Toolbar, IconButton, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import glpLogo from '../assets/glp-logo.png';

const styles = (theme) => ({
	root: {
		padding: '20px',
		flexGrow: 1
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: '33.33%',
		flexShrink: 0
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary
	},
	paperContainer: {
		padding: '20px',
		marginTop: 20
	},
	grow: {
		flexGrow: 1
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20
	},
	colorPrimary: {
		color: '#ffffff',
		backgroundColor: '#d51317'
	}
});

class TermsConditions extends React.Component {
	state = {
		expanded: null
	};

	handleChange = (panel) => (event, expanded) => {
		this.setState({
			expanded: expanded ? panel : false
		});
	};

	render() {
		const { classes } = this.props;
		const { expanded } = this.state;
		return (
			<React.Fragment className={classes.root}>
				<Paper className={classes.paperContainer}>
					{/* <div className="w3-row w3-center">
						<img src={glpLogo} alt="Global Leadership Platform" />
					</div> */}
          
          <div id='chapter1'>

<h3>1. Me Vision Ecosystem (MV) Conditions</h3>

<p>MV is an exclusive digital ecosystem for continuous personal development, uniting current and future Successful Leaders who champion our purpose: transforming leadership standards in partnership with likeminded leaders globally, by mobilising thousands—eventually millions—toward their Best Selves. We redefine leadership across all dimensions—self, others, organisations, and society (SOOS)—spanning all levels, sectors, and countries. MV connects successful leaders and individuals who’ve found their purpose, countering the negative trajectory of leadership standards, emotional well-being, unemployment of youth, the rise of AI and financial prosperity. We’re forging confident humans and powerful leaders, with financial prosperity as a reward for those who fuel our vision to mobilise 30,000 leaders by 2030, then 30,000 per country.</p>

<p>Inside MV, you may share messages—informative, inspirational, announcements, news, or anything impactful—called a LEAD, not a post or share. Every LEAD influences society, collectively and individually, to some degree. We urge members to embody their Best Self and THINK before they LEAD, as each LEAD shapes how we think. A LEAD may earn you Lead Currency (Lc) that becomes MeV, our currency, as a thank-you for adding value—potentially rewarded when others like or comment, reflecting your impact.</p>

<p>Members join MV to:</p>
<ul>
  <li>LEAD with content that helps leaders LEAD better on a Self, Others, Organisation and Society level.</li>
  <li>LEAD on any subject, amplifying their voice;</li>
  <li>LEAD with insights, wisdom, or experiences;</li>
  <li>LEAD to positively impact the world;</li>
  <li>LEAD for personal and leadership growth;</li>
  <li>LEAD to earn MeV, enhancing future influence and benefits;</li>
  <li>LEAD to build their personal or leadership brand, generating “leads” for their business, service, or cause;</li>
  <li>And much more—now and as we evolve.</li>
</ul>

<p>MV is a global community of confident individuals and Successful Leaders who see the urgent need for mature, authentic leadership. Members are honoured to participate, learning from each other, contributing positively, and striving to improve the world for future generations.</p>

<h3>How MEV Works:</h3>
<p>MV participants earn internal Lc (Lead Currency) for pledges and engagement, convertible to MEV (Me Vision)—our external currency—upon reaching thresholds set by MV management. Leaders or their sponsors pledge monthly in dollars via platforms like Patreon, which MV converts into Lc. Portions of pledges:</p>
<ul>
  <li>Reward patrons with MeV – 25% after Patreon fee is subtracted.</li>
  <li>Fund MV operations and maintenance.</li>
  <li>Build a communal pool from which members earn Lc for ecosystem activities.</li>
</ul>
<p>MV management reserves the right to adjust Lc allocation, MEV conversion ratios, and pledge distributions to ensure sustainable liquidity. This pioneering venture is dynamic—changes will occur as we learn, and we’re all grateful to replace simple gamification points with Lc and MEV instead, a currency reflecting our collective value. MV grows a wealth of leadership while fostering leaders’ prosperity. Every MEV movement signals improved leadership—individual or communal—adding tangible value to the world.</p>

<ul>
  <li><strong>Phase One:</strong> Members grow MEV portfolios, building liquidity. You acknowledge MEV’s value extraction (selling) is a future step, not yet active - in development Phase completed</li>
  <li><strong>Phase Two:</strong> As MeV gains external value, selling will phase in—staged to strengthen liquidity until investors can freely trade MEV, like any digital currency. Members commit to this evolution, understanding delays may occur as we scale and stabilise. This phase in in full swing. Members may now sell their MEV for cash in their bank accounts. However, MV Management withholds the right to determine levels allowed per month – how much MEV a member may sell in one month. Members accept this phase where no member may cash in all their MEV if it is more than the current monthly limit. This phase is important as we further strengthen liquidity and MEV price. The ultimate measurement is that the collective platform success and longevity is more important than one individual’s immediate need. The threshold decision is made through a co-signing process on the system. In other words, no individual can randomly decide what it is.</li>
  <li><strong>Authenticity Commitment:</strong> Members agree not to flood the system with “earning activities” solely for MEV, without genuine intent to develop themselves, others, organisations, society or MV. MV may audit a members’ actions to ensure they align with our purpose, reserving the right to adjust or revoke MeV if intent is misaligned.</li>
  <li><strong>Patron Requirement:</strong> Only patrons (those pledging monthly) can earn MEV. MV may, at its discretion, onboard non-patron emerging leaders with potential when the global incentive fund allows, but this is not guaranteed.</li>
  <li><strong>Improvement Architects (IA’s):</strong> We currently recruit tech savvy individuals – mostly youngsters – to drive the Global Improvement Revolution of SOOS. IA’s are allowed to earn Lc for their participation and contributions without pledging. They draw good content to the platform and earn real-time certificates as they complete one another’s tests. They therefore prepare to lead the future while helping leaders lead better in our current world.</li>
  <li><strong>Pledge Confirmation:</strong> MV confirms monthly pledges on Patreon to automatically distribute Lc.</li>
  <li><strong>Lc Conversion to MEV:</strong> Members convert their earned Lc into MEV themselves. They need to learn to do this as soon as they become active participants.</li>
</ul>

<h3>MV Features:</h3>
<ul>
  <li>A growing library of leadership content—accessible on phone, tablet, and laptop—magnetising inspiration and conversation.</li>
  <li>An exclusive space with a Global Leaderboard on LeaderTrack, able to rank members by earned Lc, feedback scores or other criteria, visible globally or by sector, country, and level. Members consent to this display (toggleable on/off), showcasing quality leaders to the world.</li>
  <li>A pioneering ecosystem potentially “professionalizing” leadership—MeV mirrors CPD points in other fields. Members compile a portfolio of participation and MeV earned, printable as evidence of growth. They receive real-time certificates as proof, recorded inside their resume.</li>
  <li>A real-time communication hub for leaders across organizations and society, tackling leadership’s communication challenge.</li>
  <li>A web-based platform (future native app possible) for all leadership content within community guidelines.</li>
  <li>A network where members follow/unfollow others, controlling LEAD notifications.</li>
  <li>An organizational tool for real-time feedback, analysis, and development from top leaders.</li>
  <li>Anonymous leadership ratings on profiles—based on four universal competencies (self, others, organization, society) or organization-specific ones—available to all members.</li>
</ul>

<h3>MV Co-Owners:</h3>
<p>Members may open their own MV ecosystems to mobilize leaders globally, earning residual commissions for recruiting paying Partners and Successful Leaders, as long as recruits remain active. Details will evolve—stay tuned.</p>

<h3>Community Guidelines:</h3>
<p>LEAD with any subject, but the following is prohibited:</p>
<ul>
  <li>Nudity or sexual content (pornography, explicit fetishes—removed without notice).</li>
  <li>Hateful content (inciting violence, dangerous/illegal acts—strictly banned).</li>
  <li>Privacy violations (sharing personal info without consent—request removal from uploader first, then report to MV).</li>
  <li>Threats (harassment, stalking, reputation damage—may result in permanent bans).</li>
  <li>Vulgar language (excessive profanity—deleted without notice).</li>
</ul>
<p>Report inappropriate content via the feedback function; MV reviews daily against these guidelines. You accept that occasional objectionable content may slip through, waiving legal claims against MV for such exposure.</p>

<h3>2. Your Personal Relationship with MV</h3>
<ul>
  <li>“MV” means Me-Vision Ecosystem, at this stage a service of ThinkLead Pty Ltd, at 2932 Korhaan Str, Marloth Park, Mpumalanga, South Africa. This may change in due course.</li>
  <li>These Terms form a legally binding contract between you and MV for your use of the Service—read them carefully.</li>
  <li>“Content” includes all text, media, courses, and materials you view, access, or contribute via the Service.</li>
</ul>

<h3>3. Accepting the Terms</h3>
<ul>
  <li>To use the Service, you must accept these Terms—accessing MV via Thinklead.app constitutes agreement.</li>
  <li>By using MV, you confirm you’re of legal age to form a binding contract (e.g., 18 under South African law, or as per your jurisdiction) and not barred from digital services under your country’s laws.</li>
  <li>If you don’t accept, you may not join—usage implies consent from your first interaction.</li>
</ul>

<h3>4. Changes to the Terms</h3>
<ul>
  <li>MV may modify these Terms to reflect legal, regulatory, or Service updates—changes will be promoted on Thinklead.app with an updated Effective Date.</li>
  <li>You’re responsible for reviewing Terms periodically—continued use after modifications signals acceptance. If you disagree, cease using MV immediately.</li>
  <li>Material changes (e.g., affecting MeV conversion) will, where feasible, include a notice period via email or platform announcement.</li>
</ul>

<h3>5. MV Accounts</h3>
<ul>
  <li>Access to features like LeaderTrack or MeV earning requires an MV account—provide accurate, current information during signup.</li>
  <li>Secure your password and notify MV at info@mevisionacademy.com immediately of any breach or unauthorized use—you’re liable for all account activity.</li>
  <li>MV grants you a non-exclusive, revocable license to use the Service, provided you don’t:
    <ol>
      <li>Distribute Content without MV’s written consent (unless enabled by MV tools);</li>
      <li>Modify the platform’s code or interface;</li>
      <li>Circumvent security features or restrictions on Content use;</li>
      <li>Harvest user data (e.g., account names);</li>
      <li>Solicit commercially via MV tools;</li>
      <li>Exploit Content without permission from MV or its licensors.</li>
    </ol>
  </li>
  <li>MV may innovate—features may change or end without notice; you accept this as part of our pioneering journey.</li>
</ul>

<h3>6. Links from MV</h3>
<ul>
  <li>MV may link to third-party sites beyond our control—we’re not responsible for their content, policies, or availability.</li>
  <li>We don’t endorse or guarantee these sites—use them at your own risk, reviewing their terms and privacy policies.</li>
  <li>MV isn’t liable for losses from third-party links, including reliance on their accuracy or offerings.</li>
</ul>

<h3>7. Ending Your Relationship with MV</h3>
<ul>
  <li>You may terminate by: (a) emailing info@mevisionacademy.com, (b) closing your account, or (c) not renewing your pledge—MV will delete your data upon written request, barring legal retention needs.</li>
  <li>MV may terminate if:
    <ol type="a">
      <li>You breach Terms (e.g., inauthentic MeV earning);</li>
      <li>Law mandates it (e.g., sanctions);</li>
      <li>Service ends in your region or becomes unviable—reasonable notice given where possible;</li>
      <li>You’re inactive and non-paying for 6+ months—account may be closed after a 30-day warning.</li>
    </ol>
  </li>
  <li>Post-termination, accrued rights (e.g., earned MeV) and obligations (e.g., confidentiality) persist as applicable.</li>
</ul>

<h3>8. Exclusion of Warranties</h3>
<ul>
  <li>MV is provided “as is”—no promises of uninterrupted, error-free, or requirement-specific use.</li>
  <li>We don’t guarantee: (a) Service meets your needs; (b) it’s always secure or timely; (c) info is accurate; (d) defects will be fixed—use at your discretion.</li>
  <li>No implied warranties (e.g., merchantability) apply beyond what law mandates.</li>
</ul>

<h3>9. Limitation of Liability</h3>
<ul>
  <li>MV isn’t liable for indirect losses (e.g., profit, goodwill, data) or damages from:
    <ol>
      <li>Reliance on ads or third-party transactions;</li>
      <li>Service changes or cessation;</li>
      <li>Data loss/corruption;</li>
      <li>Inaccurate account info or security failures on your end.</li>
      <li>MEV depreciating for whatever reason</li>
    </ol>
  </li>
  <li>Liability is capped at your total pledges paid, where law allows—direct damages only.</li>
</ul>

<h3>10. General Legal Terms</h3>
<ul>
  <li>These Terms are the full agreement—prior understandings are void.</li>
  <li>Notices (e.g., MeV updates) may come via email, mail, or Thinklead.app postings—check regularly.</li>
  <li>MV’s non-enforcement of rights isn’t a waiver—invalid provisions don’t void the rest.</li>
  <li>Governed by South African law—disputes resolved in South African courts, unless arbitration is later specified.</li>
</ul>

<h3>11. Global Contributors for MV</h3>
<ul>
  <li><strong>Organizations:</strong> MV auto-follows Global Contributors for internal messaging—members can unfollow.</li>
  <li><strong>Contributors:</strong> You’re liable for Content legality—global Content grants MV a royalty-free, worldwide license to use, ending reasonably post-deletion (server copies may remain).</li>
  <li>No third-party IP infringement—MV removes violators, may ban repeat offenders without notice.</li>
  <li>MV disclaims liability for Content accuracy or endorsement—your posts, your responsibility.</li>
</ul>


              </div>
				</Paper>
			</React.Fragment>
		);
	}
}

// TermsConditions.propTypes = {
//     classes: PropTypes.object.isRequired,
// };

export default withStyles(styles)(TermsConditions);
